<template>
  <div class="container">
    <p class="heading-1 my-4">Find a Well</p>
    <div class="grid align-items-center my-4">
      <advanced-search
        :advanced-search-items="advancedSearchItems"
        :filter-sizings-bool="filterSizings"
        page="wells"
        class="col-12 md:col-9"
      />
      <div class="col text-right">
        <Checkbox v-model="filterSizings" binary @click="toggleFilter" />
        Only Wells I've Worked On
      </div>
    </div>

    <wells-table
      :advanced-search-items="advancedSearchItems"
      :filter-sizings-bool="filterSizings"
      page="wells"
      @page-change="handlePageChanged"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import AdvancedSearch from "@/components/wells/AdvancedSearch.vue";
import { useAdvancedSearch } from "@/composables/advancedSearch/wells";
import WellsTable from "@/components/wells/WellsTable.vue";

export default defineComponent({
  components: { AdvancedSearch, WellsTable },
  setup() {
    const filterSizings = ref(false);

    const toggleFilter = function() {
      filterSizings.value = !filterSizings.value;
    };

    const advancedSearchItems = useAdvancedSearch({ filterSizings });

    function handlePageChanged(e: { page: number; rows: number }): void {
      advancedSearchItems.itemsPageNum.value = e.page;
      advancedSearchItems.itemsPerPage.value = e.rows;
    }

    return {
      advancedSearchItems,
      allWellsResults: advancedSearchItems.allWellsResults,
      filterSizings,
      toggleFilter,
      handlePageChanged
    };
  }
});
</script>

<style lang="scss" scoped></style>
